import Constants from './Constants';

const gradeList = ['tk', 'k', '1', '2', '3', '4', '5', '6', '6m', '7', '8'];

export function sanitizeGradeShortCode(gradeShortCode?: string) {
    const gradeLower = gradeShortCode?.toLowerCase() || '';
    return gradeList.includes(gradeLower) ? gradeLower : Constants.DEFAULT_GRADE_THEME;
}
